import { useEffect, useState } from 'react';

export const WAIT_TIME = 60;

export const RateLimitedErrorToast = () => {
  // countdown from 60s since the endpoint is rate-limited at ~1 req/min
  const [seconds, setSeconds] = useState(WAIT_TIME);
  const errorMsg = `Counts could not be loaded for selected date range. ${
    seconds > 0 ? `Please wait ${seconds} seconds and try again.` : 'Please retry now.'
  }`;

  useEffect(() => {
    const timer = setTimeout(() => {
      setSeconds(seconds - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [seconds]);

  return <>{errorMsg}</>;
};
